export default {
  'COLUMN':0,//栏目id
  'CONTENT':1,//内容id
  'IMAGE': 2,//图片id
  'FILE': 3,//文件id
  'VIDEO': 4,//视频库id
  'BANNER': 5,//广告位id
  'INFORMAN': 6,//信息管理id
  'REVIEW': 7,//审批管理
  'APP': 8, // 应用中心
  'SUPERADMIN': '0'
}


// WEBPACK FOOTER //
// ./src/assets/js/constans.js